var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2e30800c\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./FooterFilzfelt.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/client/pages/wrappers/FooterFilzfelt.vue
// module id = 557
// module chunks = 1